var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copyright-area"},[_vm._v(" 本网站全部服务由 Isafeclub LIMITED 独立运营、提供与维护，所有用户使用本网站、购买平台产品 / 订阅会员 / 接受安全服务，均与 Isafeclub LIMITED 建立服务法律关系。 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }